import React from "react";
import { EC_TextArea } from "../../../../../UiComponents";
export default function Subheading({ value, onChange, onFocusOut }) {
  return (
    <EC_TextArea
      // label="Sub Heading"
      onChange={onChange}
      value={value}
      onFocusOut={onFocusOut}
    />
  );
}
